module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "document"
  }, [_c('td', {
    staticClass: "document-number"
  }, [_c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.document.number),
      callback: function($$v) {
        _vm.$set(_vm.document, "number", $$v)
      },
      expression: "document.number"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "document-name"
  }, [_c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.document.name),
      callback: function($$v) {
        _vm.$set(_vm.document, "name", $$v)
      },
      expression: "document.name"
    }
  }), _vm._v(" "), (!_vm.document.document) ? _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.handleloadFile
    }
  }, [_vm._v("\n      Загрузить документ\n    ")]) : _c('span', [_c('span', {
    staticClass: "link"
  }, [_vm._v(_vm._s(_vm._f("path")(_vm.document.document)))]), _vm._v(" "), _c('span', {
    staticClass: "delete-document",
    on: {
      "click": function($event) {
        return _vm.deleteDocumentFile(_vm.document.id)
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('input', {
    ref: "loadFile",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadFile
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "date-pickers"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v("\n    —\n    "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.disclosureDate),
      callback: function($$v) {
        _vm.disclosureDate = $$v
      },
      expression: "disclosureDate"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "delete-cell"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteDocument(_vm.document.id)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8aa5bdb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Documents/DocumentItem.vue
// module id = 982
// module chunks = 0